import * as actions from '../models/actions/names';
import {
  HydrateStoreFromSession,
  IsGrammarCheckRunningAction,
  SetGcLanguage,
  SetSettingValue,
} from '../models/actions';
import { GcSettingNames } from '../models/GrammarCheck';

export const setGrammarCheckRunningAction = (
  isGrammarCheckRunning: boolean
): IsGrammarCheckRunningAction => ({
  type: actions.IS_GRAMMAR_CHECK_RUNNING,
  payload: {
    isGrammarCheckRunning,
  },
});

export const setGcSettingValue = (
  settingName: GcSettingNames,
  value: boolean | string
): SetSettingValue => ({
  type: actions.SET_SETTING_VALUE,
  payload: {
    settingName,
    value,
  },
});

export const setGcLangauge = (language: 'EN' | 'DE'): SetGcLanguage => ({
  type: actions.SET_GC_LANGUAGE,
  payload: language,
});

export const hydrateStoreFromSession = (src: string, store: any): HydrateStoreFromSession => ({
  type: actions.HYDRATE_STORE_FROM_SESSION,
  src,
  store,
});
